import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import alioss from "ali-oss";
import { makeUploadHeaders, makeUploadName, makeUploadOptions } from "../../component/ocr-autofill/utils";
import { Toast } from "antd-mobile";
import { AddOutline } from "antd-mobile-icons";

import uploadStyl from './Upload.module.scss'

type AliUploadProps = {
  disabled?: boolean;
  onUpload: (url: string)=> void;
}

const AliUpload: React.FC<AliUploadProps> = (props) => {

  // 第1步：上传图片
  const startUpload = async (file: File) => {
    const pieces = await makeUploadOptions();

    if (!pieces) {
      return;
    }

    const [prefix, options] = pieces;

    const client = new alioss(options);

    const pathname = makeUploadName(prefix, file);

    if (!pathname) {
      Toast.fail("上传缺少必要参数");
      return;
    }

    // 上传图片到OSS
    const result = await client.put(pathname, file, {
      timeout: 600 * 1000,
      headers: makeUploadHeaders(0),
    });

    if (result.res.status !== 200) {
      Toast.fail("上传失败，请重试！");
      return
    }

    props.onUpload(result.url)
  }

  const beforeUploadControl = (file: File) => {
    const [_, ext] = file.type.split('/')
    if(!['.png', '.jpg', '.jpeg'].includes(`.${ext}`)) {
      Toast.fail('上传格式不允许')
      return false
    }
    return true
  };

  const onChange = async (event: ChangeEvent<HTMLInputElement>)=> {

    const files = event.target.files;

    if (null === files || !files[0]) {
      return;
    }

    const file = files[0]

    if(!beforeUploadControl(file)) {
      return
    }

    const key = 'aliyun-loading';
    try {
      Toast.loading('正在上传...')
      await startUpload(file);
    } catch (error) {
      console.log('?aliupload', error)
    } finally {
      event.target.value = ''
      setTimeout(() => Toast.hide(), 100);
    }
  }

  return (
    <div className={uploadStyl.picker}>
      {!props.disabled && <input
        onChange={onChange}
        accept="image/png, image/jpeg"
        type="file"
      />}
      <AddOutline />
    </div>
  );
};

export default AliUpload;
